import React from 'react';
import { AiFillDelete } from 'react-icons/ai';
import { FaMinusSquare, FaPlusSquare } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Star from '../../components/Star';
import empty from '../../images/empty.png';
import { decrementQuantity, incrementQuantity, removeItem } from '../../redux/reducers/cartSlice';
import styles from '../../styles/cart.module.css';

function Cart() {
  const navigate = useNavigate();
  const { cart } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const checkoutHandler = () => {
    if (cart.length === 0) {
      return;
    }
    navigate('/shipping');
  };

  const calculateSubtotal = () => {
    return cart.reduce((acc, item) => acc + item.quantity * item.price, 0);
  };

  const calculateTotalItems = () => {
    return cart.reduce((acc, item) => acc + item.quantity, 0);
  };

  return (
    <div className={styles.cartContainer}>
      <Navbar />
      
      {cart.length !== 0 ? (
        <div className={styles.cartWrapper}>
          <div className={styles.cartItemsSection}>
            <h3 className={styles.sectionTitle}>Shopping Cart</h3>
            
            {cart.map((elem, i) => (
              <div className={styles.cartItem} key={i}>
                <div className={styles.itemImageWrapper}>
                  <img 
                    src={elem.image} 
                    className={styles.itemImage} 
                    alt={elem.name} 
                  />
                </div>
                
                <div className={styles.itemDetails}>
                  <Link to={`/product/${elem._id}`} className={styles.itemName}>
                    {elem.name}
                  </Link>
                  
                  <div className={styles.itemRating}>
                    <Star 
                      stars={elem.rating} 
                      reviews={elem.numReviews} 
                    />
                  </div>
                  
                  <div className={styles.itemPrice}>
                    Price: ${elem.price}
                  </div>
                  
                  <div className={styles.itemQuantity}>
                    <span>Quantity: {elem.quantity}</span>
                    <div className={styles.quantityControls}>
                      <FaPlusSquare 
                        onClick={() => dispatch(incrementQuantity(elem._id))} 
                        className={styles.quantityIcon}
                      />
                      <FaMinusSquare 
                        onClick={() => dispatch(decrementQuantity(elem._id))} 
                        className={styles.quantityIcon}
                      />
                      <AiFillDelete 
                        onClick={() => dispatch(removeItem(elem._id))} 
                        className={styles.deleteIcon}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.summarySection}>
            <h3 className={styles.summaryTitle}>Order Summary</h3>
            
            <div className={styles.summaryRow}>
              <span>Subtotal</span>
              <span>{calculateTotalItems()} items</span>
            </div>
            
            <div className={styles.summaryRow}>
              <span>Total</span>
              <span className={styles.summaryTotal}>
                ${calculateSubtotal()}
              </span>
            </div>
            
            <button
              type="button"
              className={styles.checkoutBtn}
              disabled={cart.length === 0}
              onClick={checkoutHandler}
            >
              Proceed to Checkout
            </button>
          </div>
        </div>
      ) : (
        <div className={styles.emptyCart}>
          <img src={empty} alt="Empty cart" className={styles.emptyImage} />
          <h3 className={styles.emptyTitle}>Your cart is empty</h3>
          <p className={styles.emptyText}>Looks like you haven't added any items to your cart yet.</p>
          <button 
            className={styles.continueShoppingBtn} 
            onClick={() => navigate('/')}
          >
            Continue Shopping
          </button>
        </div>
      )}
    </div>
  );
}

export default Cart;